import { TournamentInvitation } from '../models';
import { TournamentInvitationRepository } from '../repositories/TournamentInvitationRepository';
import { logger } from '@/src/core/utils';

export class DeclineTournamentInvitationUseCase {
  constructor(private invitationRepository: TournamentInvitationRepository) {}

  async execute(invitationId: string): Promise<TournamentInvitation> {
    logger.debug('DeclineInvitation', 'Declining invitation', { invitationId });
    return this.invitationRepository.decline(invitationId);
  }
}
